export default "__VITE_ASSET__Eo8dt9U9__"